var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCollege(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    opacity: 0.05,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512.001 512.001",
    style: {
      enableBackground: "new 0 0 512.001 512.001"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 256.001,
    y: 8.063,
    style: {
      fill: "#A5C6E3"
    },
    width: 96.001,
    height: 39.995
  }), /*#__PURE__*/React.createElement("rect", {
    x: 295.995,
    y: 32.063,
    style: {
      fill: "#A5C6E3"
    },
    width: 96.001,
    height: 39.995
  }), /*#__PURE__*/React.createElement("rect", {
    y: 319.389,
    style: {
      fill: "#A5C6E3"
    },
    width: 120.005,
    height: 24.674
  }), /*#__PURE__*/React.createElement("rect", {
    x: 391.997,
    y: 319.389,
    style: {
      fill: "#A5C6E3"
    },
    width: 120.005,
    height: 24.674
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    y: 342.689,
    style: {
      fill: "#36A9E1"
    },
    width: 120.005,
    height: 161.375
  }), /*#__PURE__*/React.createElement("rect", {
    x: 391.997,
    y: 342.689,
    style: {
      fill: "#36A9E1"
    },
    width: 120.005,
    height: 161.375
  }), /*#__PURE__*/React.createElement("rect", {
    x: 112.004,
    y: 232.061,
    style: {
      fill: "#36A9E1"
    },
    width: 288.005,
    height: 24
  })), /*#__PURE__*/React.createElement("rect", {
    x: 96.002,
    y: 208.068,
    style: {
      fill: "#A5C6E3"
    },
    width: 319.998,
    height: 24
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#36A9E1"
    },
    points: "432,208.063 80.001,208.063 80.001,176.063 256.001,120.062 432,176.063 "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 120.005,
    y: 256.064,
    style: {
      fill: "#1D71B8"
    },
    width: 272.003,
    height: 248
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 160.125,
    y: 288.068,
    style: {
      fill: "#A5C6E3"
    },
    width: 15.75,
    height: 184.002
  }), /*#__PURE__*/React.createElement("rect", {
    x: 208.121,
    y: 288.068,
    style: {
      fill: "#A5C6E3"
    },
    width: 15.75,
    height: 184.002
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256.126,
    y: 288.068,
    style: {
      fill: "#A5C6E3"
    },
    width: 15.75,
    height: 184.002
  }), /*#__PURE__*/React.createElement("rect", {
    x: 304.122,
    y: 288.068,
    style: {
      fill: "#A5C6E3"
    },
    width: 15.75,
    height: 184.002
  }), /*#__PURE__*/React.createElement("rect", {
    x: 352.128,
    y: 288.068,
    style: {
      fill: "#A5C6E3"
    },
    width: 15.75,
    height: 184.002
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    y: 496.188,
    style: {
      fill: "#1D1D1B"
    },
    width: 512.001,
    height: 15.75
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#1D1D1B"
    },
    points: "399.875,488.062 384.125,488.062 384.125,263.937 127.875,263.937 127.875,488.062  112.125,488.062 112.125,248.187 399.875,248.187  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#1D1D1B"
    },
    points: "144,287.937 152.125,287.937 152.125,472.188 144,472.188 144,487.938 176,487.938  176,472.188 167.875,472.188 167.875,287.937 176,287.937 176,272.187 144,272.187  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#1D1D1B"
    },
    points: "192,287.937 200.125,287.937 200.125,472.188 192,472.188 192,487.938 224,487.938  224,472.188 215.875,472.188 215.875,287.937 224,287.937 224,272.187 192,272.187  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#1D1D1B"
    },
    points: "240,287.937 248.126,287.937 248.126,472.188 240,472.188 240,487.938 272,487.938  272,472.188 263.876,472.188 263.876,287.937 272,287.937 272,272.187 240,272.187  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#1D1D1B"
    },
    points: "288,287.937 296.124,287.937 296.124,472.188 288,472.188 288,487.938 320,487.938  320,472.188 311.875,472.188 311.875,287.937 320,287.937 320,272.187 288,272.187  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#1D1D1B"
    },
    points: "368.001,287.937 368.001,272.187 359.875,272.187 359.875,272.063 344.125,272.063  344.125,272.187 336,272.187 336,287.937 344.125,287.937 344.125,472.188 336,472.188 336,487.938 368.001,487.938  368.001,472.188 359.875,472.188 359.875,287.937  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96.002,
    y: 224.186,
    style: {
      fill: "#1D1D1B"
    },
    width: 319.998,
    height: 15.75
  }), /*#__PURE__*/React.createElement("rect", {
    y: 312.186,
    style: {
      fill: "#1D1D1B"
    },
    width: 104.003,
    height: 15.75
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1D1D1B"
    },
    d: "M263.876,114.304V0.063h-15.75v114.242l-176.001,56v45.633h367.75v-45.633L263.876,114.304z  M424.125,200.188H87.875v-18.367l168.125-53.494l168.125,53.494v18.367H424.125z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#1D1D1B"
    },
    points: "359.875,55.938 272,55.938 272,40.188 344.125,40.188 344.125,15.938 272,15.938 272,0.188  359.875,0.188  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#1D1D1B"
    },
    points: "399.875,79.938 312,79.938 312,64.188 384.125,64.188 384.125,39.938 368.001,39.938  368.001,24.188 399.875,24.188  "
  })), /*#__PURE__*/React.createElement("rect", {
    x: 248.126,
    y: 160.062,
    style: {
      fill: "#FFFFFF"
    },
    width: 15.75,
    height: 16
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 8.015,
    y: 336.041,
    transform: "matrix(-1 -0.0032 0.0032 -1 102.9308 687.9977)",
    style: {
      fill: "#1D1D1B"
    },
    width: 88.001,
    height: 15.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.019,
    y: 416.324,
    transform: "matrix(-1 -0.0032 0.0032 -1 102.6809 848.5632)",
    style: {
      fill: "#1D1D1B"
    },
    width: 88.001,
    height: 15.75
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 24.125,
    y: 368.067,
    style: {
      fill: "#FFFFFF"
    },
    width: 15.75,
    height: 32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64.124,
    y: 368.067,
    style: {
      fill: "#FFFFFF"
    },
    width: 15.75,
    height: 32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24.125,
    y: 448.067,
    style: {
      fill: "#FFFFFF"
    },
    width: 15.75,
    height: 32.001
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64.124,
    y: 448.067,
    style: {
      fill: "#FFFFFF"
    },
    width: 15.75,
    height: 32.001
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 407.999,
    y: 312.186,
    style: {
      fill: "#1D1D1B"
    },
    width: 104.002,
    height: 15.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 416.017,
    y: 336.023,
    transform: "matrix(-1 -0.0032 0.0032 -1 918.9322 689.2664)",
    style: {
      fill: "#1D1D1B"
    },
    width: 88.001,
    height: 15.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 416.021,
    y: 416.307,
    transform: "matrix(-1 -0.0032 0.0032 -1 918.6823 849.834)",
    style: {
      fill: "#1D1D1B"
    },
    width: 88.001,
    height: 15.75
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 432.128,
    y: 368.067,
    style: {
      fill: "#FFFFFF"
    },
    width: 15.75,
    height: 32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 472.122,
    y: 368.067,
    style: {
      fill: "#FFFFFF"
    },
    width: 15.75,
    height: 32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 432.128,
    y: 448.067,
    style: {
      fill: "#FFFFFF"
    },
    width: 15.75,
    height: 32.001
  }), /*#__PURE__*/React.createElement("rect", {
    x: 472.122,
    y: 448.067,
    style: {
      fill: "#FFFFFF"
    },
    width: 15.75,
    height: 32.001
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollege);
export default __webpack_public_path__ + "static/media/college.0a00b0b10bd2924965f6a45b5f716761.svg";
export { ForwardRef as ReactComponent };